export default __webpack_public_path__ + "static/media/discount-stamp.37983b12.svg";